module.exports = __webpack_public_path__ + "static/stores-ordering-9db88b38330326cc56e261ca2e705e42.png";